//file:///D:/projects/License%20App/html/additional-recepients.html

import React, { Component } from 'react';


import axios from 'axios';

import config from '../../config';

import Header from '../common/header';

import Footer from '../common/footer';

import { Redirect } from 'react-router-dom'

import queryString from 'query-string';

export default class KeyReady extends Component {


    constructor(props) {
        super(props);

        this.sendBtnTexts = {
            send: 'Send',
            sendWith: 'Send with additional recepients',
        };

        this.state = {
            sendBtnTxt: this.sendBtnTexts.send,
            needsEmailVerification: true,
            verifiedEmail: config.getVerifiedEmail() || '',
            varifiedEmailValid: '',
            additionalEmails: '',
            phone: '',
            customerEmail: config.getVerifiedEmail() || config.getPurchaserEmail() || '',
            customerName: '',

            keySent: false,
            checked: true,
        };


        this.verifyEmailBtn = this.verifyEmail.bind(this);
        this.onVerificationEmailChange = this.verificationEmailChanged.bind(this);


        this.onAdditionalEmailsChange = this.additionalEmailsChanged.bind(this);
        this.onPhoneChange = this.phoneChanged.bind(this);

        this.additionalEmailsBtn = this.additionalEmails.bind(this);

        this.handleEmailEnter = this.handleEmailEnter.bind(this);

        this.qs = queryString.parse(window.location.search);
        this.onCustomerEmailChange = this.customerEmailChanged.bind(this);
        this.onCustomerNameChange = this.customerNameChanged.bind(this);

        // this.termsBtn = this.terms.bind(this);
        this.handleCheck = this.handleCheck.bind(this);

    }
    /* terms() {
         this.setState({
             redirectTerms: '/terms?key=' + this.qs.key
         });
     }*/

    customerEmailChanged(event) {
        this.setState({ customerEmail: event.target.value });
    }

    customerNameChanged(event) {
        this.setState({ customerName: event.target.value });
    }

    verificationEmailChanged(event) {
        this.setState({ verifiedEmail: event.target.value });
    }

    additionalEmailsChanged(event) {

        this.setState({ additionalEmails: event.target.value });

        // if (!this.state.additionalEmails.length) {
        //     return this.setState({
        //         sendBtnTxt: this.sendBtnTexts.send
        //     });
        // }

        // this.setState({
        //     sendBtnTxt: this.sendBtnTexts.sendWith
        // });
    }

    phoneChanged(event) {
        this.setState({ phone: event.target.value });
    }

    handleEmailEnter(event) {
        if (event.key === 'Enter') {
            this.verifyEmail();
        }
    }
    handleCheck() {
        this.setState({ checked: !this.state.checked });
        this.setState({
            termsValid: 'valid'
        });
    }
    verifyEmail() {

        if (!this.state.verifiedEmail.length) {
            this.setState({
                varifiedEmailValid: 'error'
            });

            return;
        }

        config.setVerifiedEmail(this.state.verifiedEmail);
        this.sendLicense();
    }

    additionalEmails() {
        if (this.state.phone.length) {
            if (this.state.phone.length != 10 || !/[0-9]/.test(this.state.phone)) {
                this.setState({
                    phoneValid: 'error'
                });
                return;
            }

            this.setState({
                phoneValid: 'valid'
            });
        }
        if (!this.state.checked) {
            this.setState({
                termsValid: 'error'
            });
            return;
        }
        else {
            this.setState({
                termsValid: 'valid'
            });
        }
        if (this.state.customerName.length) {
            this.setState({
                customerNameValid: 'valid',
                customerName: this.state.customerName
            })
        } else {
            this.setState({
                customerNameValid: 'error'
            })
            return
        }

        if (this.state.customerEmail.length) {
            if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.customerEmail)) {
                this.setState({
                    customerEmailValid: 'valid'
                })
                config.setVerifiedEmail(this.state.customerEmail)
                config.setPurchaserEmail(this.state.customerEmail)
            } else {
                this.setState({
                    customerEmailValid: 'error'
                });
                return;
            }

        } else {
            this.setState({
                customerEmailValid: 'error'
            });
            return;
        }


        var verifiedEmailexist = config.getVerifiedEmail();
        if (verifiedEmailexist) {
            this.sendLicense();
            return;
        }
        this.setState({
            needsEmailVerification: false
        });
        return;
    }

    sendLicense() {
        console.log('hello')
        axios.get(`${config.baseUrl}`, {
            params: {
                action: 'getgeneratelincesekey',
                activation_key: this.qs.key || '',
                additional_emails: this.state.additionalEmails,
                phone: this.state.phone,
                verify_email: this.state.verifiedEmail || config.getVerifiedEmail(),
                customer_email: this.state.verifiedEmail || config.getVerifiedEmail(),
                customer_name: this.state.customerName
            }
        }).then((e) => {

            const response = e.data;

            if (response.status == 'success') {

                const data = response.data || {};

                if (data.activation_status === 'Case 3') {
                    config.setLicenseKey(data.license_key);
                    this.setState({
                        keySent: true
                    });
                    return;
                }

                if (data.activation_status === 'Case 2') {
                    config.setLicenseKey(data.license_key);
                    this.setState({
                        keySent: true
                    });
                    return;
                }

                if (data.activation_status === 'Case 1') {
                    this.setState({
                        varifiedEmailValid: 'error',
                        verifyEmailInputClass: '',
                        emailError: data.activation_response,
                        needsEmailVerification: false,
                    });
                    config.setVerifiedEmail('');
                    return;
                }

                return;

            }

        });

    }

    render() {

        if (this.state.redirectTerms) {
            return (<Redirect to={this.state.redirectTerms} push />);
        }

        if (this.state.keySent) {
            return <Redirect to={'/sent?key=' + this.qs.key} push />
        }

        return (
            <div className="wrapper">

                <Header></Header>

                <section className="content">
                    <div className="container-pf-mini py-md-27 py-20">
                        <div className="row">
                            <div className="col-md-8 offset-md-2">
                                <h3 className='fw-medium'>Activating {config.getLicenseName()}</h3>

                                <div className="step mb-4">
                                    <p>Step 3 of 3</p>
                                </div>

                                <div style={{ display: this.state.needsEmailVerification === false ? 'none' : 'block' }}>

                                    <h5 className="mb-4 fw-medium">Your License Key is ready and will be sent to your email</h5>
                                    <fieldset className={'mt-4 ' + this.state.varifiedEmailValid}>
                                        <h5 className="mb-3 fw-medium">Name <span className="light"></span></h5>
                                        <input type="text" placeholder="Enter name..." onChange={this.onCustomerNameChange} />
                                    </fieldset>
                                    <p className="small fs-6 mt-3" style={{ display: this.state.customerNameValid === 'error' ? 'block' : 'none' }}>Please enter your name.</p>
                                    <fieldset className={'mt-4 ' + this.state.varifiedEmailValid}>
                                        <h5 className="mb-3 fw-medium">Email</h5>
                                        <input type="Email" placeholder="Enter email..." defaultValue={config.getPurchaserEmail()} onChange={this.onCustomerEmailChange} />

                                    </fieldset>
                                    <p className="small fs-6 mt-3 fs-6" style={{ display: this.state.customerEmailValid === 'error' ? 'block' : 'none' }}>The email you entered does not look valid.</p>
                                    <h4 className="text-center mt-4 fw-medium">Additional Recepients</h4>
                                    <p className='fs-5'>Use the option if you are not the original purchaser of the software and is required by purchaser to activate the monitor. Leave the fields blank if not needed.</p>
                                </div>


                                <div className="form mb-0" style={{ display: this.state.needsEmailVerification === true ? 'none' : 'block' }}>

                                    <fieldset className={this.state.varifiedEmailValid}>
                                        <h5 className="mb-3 fw-medium">Verify email </h5>
                                        <input type="Email" placeholder="Enter email..." onChange={this.onVerificationEmailChange} onKeyDown={this.handleEmailEnter} />
                                    </fieldset>

                                    <p className="small fs-6 mt-3" style={{ display: this.state.varifiedEmailValid === 'error' ? 'block' : 'none' }}>The email you entered does not look valid. Try again.</p>


                                    <fieldset className=" mt-4">
                                        <button onClick={this.verifyEmailBtn} type="button" className="text-center btn btn-violet-3 fs-md-6 fs-5 fw-bold px-6 py-4">Send <i className="fa fa-paper-plane-o ml-2" aria-hidden="true"></i></button>
                                    </fieldset>

                                </div>

                                <div className="form mb-0" style={{ display: this.state.needsEmailVerification === false ? 'none' : 'block' }}>
                                    <form>
                                        <fieldset className="">
                                            <h5 className="mb-3 fw-medium">Additional Email Recepients (Optional)</h5>
                                            <input type="Email" placeholder="Enter emails seperated by comma..." onChange={this.onAdditionalEmailsChange} />
                                        </fieldset>

                                        <fieldset className={'mb-2 d-none ' + this.state.phoneValid}>
                                            <h5 className="mb-3 fw-medium">Phone (Optional)</h5>
                                            <input type="tel" placeholder="..." onChange={this.onPhoneChange} max="10" />
                                        </fieldset>
                                        <p style={{ display: this.state.phoneValid == 'error' ? 'block' : 'none' }}>The phone you entered does not look valid.</p>
                                        <div className={this.state.termsValid == 'error' ? 'form-check fs-6 error' : 'form-check fs-6'}>
                                            <input type="checkbox" className={this.state.termsValid == 'error' ? 'form-check-input terms-input error' : 'form-check-input terms-input'} id="terms" name="terms" defaultChecked={this.state.checked} onChange={this.handleCheck} />
                                            <label className="form-check-label term-e" htmlFor="terms">I have read and agree to the <a className="text-primary" href="https://smallhd.com/pages/smallhd-camera-control-license-end-user-license-agreement" target="_blank" rel="noopener noreferrer">terms of service</a></label>
                                            <p className="small fs-6 mt-3 fs-6" style={{ display: this.state.termsValid === 'error' ? 'block' : 'none' }}>Please check before proceeding.</p>
                                        </div>
                                        <fieldset className="submit mb-0">
                                            <button onClick={this.additionalEmailsBtn} type="button" className="btn-block btn btn-violet-3 text-center fs-5 fs-md-6 fw-bold px-6 py-4">{this.state.additionalEmails.length ? this.sendBtnTexts.sendWith : this.sendBtnTexts.send} <i className="fa fa-paper-plane-o ml-2" aria-hidden="true"></i></button>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />

            </div>
        );
    }



}